<template>
  <div class="restrictions__data">
      <v-toolbar-title v-if="data.length > 0"  class="v-data-table__title">
      {{ $t('tab_restrictions_title', { product_name: 'Vistor parking'}) }}
      </v-toolbar-title>
      <v-toolbar-title v-else  class="v-data-table__title">
      {{ $t('no_restrictions_title') }}
      </v-toolbar-title>
      <span v-if="data.length === 0" class="form-dialog__subtitle">
        {{ $t('no_restrictions_description') }}
      </span>
    <v-data-table
      v-if="data.length > 0"
      class="data__table table-weekday"
      ref="table"
      :headers="headers"
      :items="data"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="mobileBreakpoint"
    >
    <template v-slot:item.time_of_day_start="{ item }">
      <span :class="getTextColor(item)">
          {{ item.time_of_day_start }}
      </span>
  </template>
  <template v-slot:item.time_of_day_end="{ item }">
      <span :class="getTextColor(item)">
            {{ item.time_of_day_end }}
      </span>
  </template>
    <template v-slot:item.valid_from="{ item }">
      <span :class="getTextColor(item)">
            {{ formatDate(item.valid_from) }}
      </span>
  </template>

  <template v-slot:item.valid_to="{ item }">
      <span :class="getTextColor(item)">
            {{ formatDate(item.valid_to) }}
      </span>
  </template>
  <template v-slot:item.days="{ item }">
  <span
    v-for="day in item.days"
    :key="day"
    :class="getBadgeColor(item)"
  >
    {{ getWeekdayLabel(day) }}
  </span>
</template>
      <template v-slot:item.ids="{ item }">
        <div class="mobile-row__action">
          <div>
            <v-btn
            v-if="!isRowExpired(item)"
              class="pkmn-button pkmn-button--no-padding data__action-button"
              text
              color="primary"
              @click="edit(item)"
            >
              <img src="@/assets/button-edit.svg" />
            </v-btn>
          </div>
        </div>
      </template>
    </v-data-table>

    </div>
</template>
<script>

export default {
  props: {
    currencyId: {
      type: Number,
      default: 0
    },
    backendData: {
      type: Array,
      default: () => []
    }
  },
  name: 'TabRestrictions',
  data() {
    return {
      data: [],
      weekdays: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
      headers: [
        { text: this.$t('from'), value: 'time_of_day_start' },
        { text: this.$t('to'), value: 'time_of_day_end' },
        { text: this.$t('valid_from'), value: 'valid_from' },
        { text: this.$t('valid_until'), value: 'valid_to' },
        { text: this.$t('weekdays'), value: 'days' },
        { text: '', value: 'ids'}
      ],
      mobileBreakpoint: 767, // screen width in pixel to switch to mobile view

    };
  },
  methods: {
    toHHmmss(timeStr) {
      if (!timeStr) return timeStr
      const parts = String(timeStr).split(':')
      const h = (parts[0] || '00').padStart(2, '0')
      const m = (parts[1] || '00').padStart(2, '0')
      const s = (parts[2] || '00').padStart(2, '0')
      return `${h}:${m}:${s}`
    },
    edit(item) {
      this.$emit('edit', item)
    },
    formatDate(ts) {
      if (!ts) return this.$t('further_notice');

      const date = new Date(ts * 1000); 
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    },
    isRowExpired(item) {
      if (!item.valid_to) return false; 

      const now = Math.floor(Date.now() / 1000); 
      return item.valid_to < now;
    },
    getWeekdayLabel(day) {
      return this.weekdays[day-1];
    },
    getTextColor(item) {
      return this.isRowExpired(item) ? 'expired-text' : '';
    },
    getBadgeColor(item) {
        return this.isRowExpired(item) ? 'weekday-badge-expired' : 'weekday-badge';
    },
    groupAllowedTimes(backendData) {
      if (backendData.length === 0) {
        return []
      }
      const groupedMap = new Map();

      backendData.forEach(item => {
        const todStart = this.toHHmmss(item.time_of_day_start)
        const todEnd = this.toHHmmss(item.time_of_day_end)
        const key = [
          todStart,
          todEnd,
          item.valid_from,
          item.valid_to
        ].join('|');

        if (!groupedMap.has(key)) {
          groupedMap.set(key, {
            ids: [item.id],
            location_product_id: item.location_product_id,
            days: [item.day_of_week_start],
            time_of_day_start: todStart,
            time_of_day_end: todEnd,
            valid_from: item.valid_from,
            valid_to: item.valid_to
          });
        } else {
          const existing = groupedMap.get(key);
          existing.ids.push(item.id);
          existing.days.push(item.day_of_week_start);
        }
      });

      return Array.from(groupedMap.values()).sort((a, b) => {
        const now = Math.floor(Date.now() / 1000);

        const aExpired = a.valid_to != null && a.valid_to < now;
        const bExpired = b.valid_to != null && b.valid_to < now;

        if (aExpired && !bExpired) return -1;
        if (!aExpired && bExpired) return 1;

        if (a.valid_from !== b.valid_from) {
          return a.valid_from - b.valid_from;
        }

        if (a.valid_to == null && b.valid_to == null) return 0;
        if (a.valid_to == null) return 1;
        if (b.valid_to == null) return -1;

        return a.valid_to - b.valid_to;
      })
    }
  },
  watch: {
    backendData(newVal) {
      if (newVal) {
        this.data = this.groupAllowedTimes(newVal)
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/common';

.v-data-table__title {
  @include text-body;
  font-weight: 700;
  color: $text-color-dark;
}

.table-weekday {
  width: 770px;
  padding-top: 8px;
}

.restrictions__data {
  padding-top: 32px;
}

.row--expired {
  color: #999 !important;
}

.weekday-badge {
  display: inline-block;
  padding: 4px 8px;
  margin: 2px;
  border-radius: 12px;
  background-color: rgba(55, 189, 1, 0.10);
  font-size: 12px;
  color: #333;
  text-transform: capitalize;
}

.weekday-badge-expired {
  display: inline-block;
  padding: 4px 8px;
  margin: 2px;
  border-radius: 12px;
  background-color: rgba(55, 189, 1, 0.10);
  font-size: 12px;
  color: #B9B9B9;
  text-transform: capitalize;
}

.expired-text {
  color: #999 !important;
}
</style>